import React from 'react'
import PropTypes from 'prop-types'
import { Flex } from '@jisr-hr/design-system'
import { Typography } from '@jisr-hr/ds'
import { ReactComponent as UserGroupIcon } from '@jisr-hr/design-system/dist/assets/icons/User/Group/User/Default.svg'
import I18n from 'translations/i18n'
import Frame from 'components/global/templates/RequestDrawer/ds/Frame'
import styles from './styles.module.css'

const HiringEmployeesDetails = ({ employeesNumber, position, hiringMonth }) => {
  return (
    <Frame
      title={I18n.t('hiring_details')}
      customStyle={styles.frame}
    >
      <Flex justifyBetween>
        <div>
          <Typography
            text={position}
            style={{ color: 'var(--color-base-colors-black-500)' }}
            variant="subheading"
          />
          <Typography
            text={hiringMonth}
            style={{ color: 'var(--color-base-colors-black-500)' }}
            variant="subheading"
            textColor="color/fg/lighter"
          />
        </div>
        <Flex
          itemsCenter
          style={{ height: 'fit-content' }}
        >
          <UserGroupIcon style={{ margin: '0 8px', width: 16, height: 16 }} />
          <Typography
            text={employeesNumber}
            style={{ color: 'var(--color-base-colors-black-500)' }}
            variant="interface/strong/m"
          />
        </Flex>
      </Flex>
    </Frame>
  )
}

HiringEmployeesDetails.propTypes = {
  employeesNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  position: PropTypes.string,
  hiringMonth: PropTypes.string,
}

export default HiringEmployeesDetails
